import React from 'react';
import Icon from './Icon';

const FilterIcon = ({ size, className, ...props }) => {
  return (
    <Icon size={size} className={className} {...props}>
      <path 
        d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default FilterIcon;
